module.exports = __webpack_public_path__ + "static/media/adobe-xd.7cb63265.svg";